import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";
import Header from "../header/Header";
import HeroHome from "./home/HeroHome";
import ScrollFixed from "./home/ScrollFixed";
import ScrollFixedMobile from "./home/ScrollFixedMobile";
import SliderBig from "./home/SliderBig";
import PlanesNuevosEnHome from "./planes/TablasPlanes";
import GiftCard from "./home/GiftCard";
import FuncionesExperienciaUnica from "./home/FuncionesExperienciaUnica";
import Carousel from "./home/Carousel";
import Convierte from "./home/Convierte";
import Faqs from "./home/Faqs";
import { accordionData } from "./home/FaqsData";
import Footer from "../footer/Footer";

function Home() {
  const isMobile = useMediaQuery({
    query: "(max-width: 995px)",
  });

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <meta charSet="utf-8" />
        <title>XDigital Neo</title>
      </Helmet>
      <Header />
      <div
        style={{ position: "relative", zIndex: 10, backgroundColor: "black" }}
      >
        <HeroHome />
      </div>
      {isMobile ? <ScrollFixedMobile /> : <ScrollFixed />}
      <SliderBig />
      <PlanesNuevosEnHome
        className="enHome"
        title="FáCIL DE VER, FáCIL DE ELEGIR."
        copy="Opta por uno de los planes que tenemos para ti, y empieza a disfrutar de la nueva forma de vivir le TV y el Cine."
      />
      <GiftCard />
      <FuncionesExperienciaUnica />
      <Carousel />
      <Convierte />
      <Faqs accordionData={accordionData} />
      <Footer />
    </>
  );
}

export default Home;
